module.exports = __webpack_public_path__ + "media/images/socials/reddit-d736b3da262bde846121b5a4090c0308.png";